/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import AddressComponent from 'src/components/AddressComponent';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import RoutingUtil from 'src/utils/RoutingUtil';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { useHistory } from 'react-router';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import FormikSelect from 'src/components/formik/FormikSelect';
import { isProduction } from 'src/config/index';
import { withFormikDevtools } from 'formik-devtools-extension';
import UserDropDown from 'src/business-components/UserDropDown';
import FormikToggle from 'src/components/formik/FormikToggle';
import UserInfoComponent from 'src/components/UserInfoComponent';
import FormikInput from 'src/components/formik/FormikInput';
import FormikCheckBox from 'src/components/formik/FormikCheckBox';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import classNames from 'classnames';
import FormikPassword from 'src/components/formik/FormikPassword';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { includeStamp } from 'src/utils/StampUtils';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import { userResetAction, userUpsertAction } from './actions/UserActions';
import { UserYupSchema } from './UserPropTypes';
import {
    EMPLOYMENT_TYPES_LIST, USER_TYPES_LIST, DESIGNATION_TYPES_LIST, FIRM_TYPES_LIST, DEPARTMENTS_LIST,
} from './UserConstants';
import PictureContainer from '../files-container/PictureContainer';
import FileContainer from '../files-container/FileContainer';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        initialValues,
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;

    return (
        <div>
            <Form autoComplete="disabled">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Office Details</h5>
                        <div className="form-row">
                            <div className="form-group col-md-3">
                                <label>User ID</label>
                                <FormikInput
                                    name="userId"
                                    type="text"
                                    className="form-control"
                                    disabled={initialValues.userId}
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>Employment Type</label>
                                <FormikSelect
                                    items={EMPLOYMENT_TYPES_LIST}
                                    name="employmentType"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>Reporting Manager</label>
                                <UserDropDown
                                    name="reportingManagerId"
                                    value={values.reportingManagerId}
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>User Type</label>
                                <FormikSelect
                                    items={USER_TYPES_LIST}
                                    name="userType"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>Designation</label>
                                <FormikSelect
                                    items={DESIGNATION_TYPES_LIST}
                                    name="designation"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>Department</label>
                                <FormikSelect
                                    items={DEPARTMENTS_LIST}
                                    name="department"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>Company</label>
                                <CompanyDropDown
                                    value={values.companyId}
                                    name="companyId"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card mt-3">
                    <div className="card-body">
                        <h5 className="card-title">Personal Details</h5>

                        <div className="form-row">
                            <div className="form-group col">
                                <PictureContainer
                                    source="users"
                                    refId={values._id}
                                    className="img-thumbnail profile-picture"
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col">
                                <FormikToggle
                                    name="active"
                                />
                            </div>
                        </div>

                        <UserInfoComponent
                            values={values.personalInfo}
                            name="personalInfo"
                        />

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label>Password</label>
                                <FormikPassword
                                    name="password"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="border-top my-3" />
                        <div className="form-group">
                            <h5>Present Address</h5>
                            <AddressComponent
                                values={values.presentAddress}
                                name="presentAddress"
                            />
                        </div>

                        <div className="border-top my-3" />
                        <div className="form-group">
                            <h5>
                                Permanent Address
                                {' '}
                                <small>same as present address</small>
                                <FormikCheckBox
                                    className="ml-2 big-checkbox"
                                    name="presentAddressIsPermanentAddress"
                                />
                            </h5>
                            <AddressComponent
                                className={classNames({
                                    'd-none': values.presentAddressIsPermanentAddress,
                                })}
                                values={values.permanentAddress}
                                name="permanentAddress"
                            />
                        </div>
                    </div>
                </div>

                <div className="card mt-3">
                    <div className="card-body">
                        <h5 className="card-title">Bank Details</h5>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label>Pan Card</label>
                                <FormikInput
                                    className="form-control"
                                    name="bankInfo.pancard"
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>Account Number</label>
                                <FormikInput
                                    className="form-control"
                                    name="bankInfo.accountNumber"
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>IFSC Code</label>
                                <FormikInput
                                    className="form-control"
                                    name="bankInfo.ifisc"
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>Bank Name</label>
                                <FormikInput
                                    className="form-control"
                                    name="bankInfo.bankName"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card mt-3">
                    <div className="card-body">
                        <h5 className="card-title">
                            GST Applicable
                            <FormikCheckBox
                                className="ml-2 big-checkbox"
                                name="gst.applicable"
                            />
                        </h5>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label>Name of Firm</label>
                                <FormikInput
                                    className="form-control"
                                    name="gst.firmName"
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>
                                    Status
                                </label>
                                <FormikSelect
                                    items={FIRM_TYPES_LIST}
                                    name="gst.firmType"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>GSTIN Number</label>
                                <FormikInput
                                    className="form-control"
                                    name="gst.gstin"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center py-4 mt-3">
                    <FormikCreateSearchClear
                        isSubmitting={isSubmitting}
                        isUpdate={Boolean(values._id)}
                        onSearch={onSearch}
                        onClear={onClear}
                        resetForm={resetForm}
                        values={values}
                        submitScope="people.user_manager.manage.submit"
                        searchScope="people.user_manager.manage.search"
                    />
                </div>
            </Form>

            <div className="form-group">
                <RemarkComponent
                    source="users"
                    refId={values._id}
                    title="User Remarks"
                />
            </div>

            <PermissionHOC
                scope="people.user_manager.manage.file_upload"
                fallback={(
                    <FileContainer
                        title="User Files"
                        source="users"
                        refId={values._id}
                        className="mt-3"
                        canUpload={false}
                    />
                )}
                component={(
                    <FileContainer
                        title="User Files"
                        source="users"
                        refId={values._id}
                        className="mt-3"
                    />
                )}
            />
        </div>
    );
};

Render.propTypes = {
    initialValues: PropTypes.any.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onClear: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.any,
        permanentAddress: PropTypes.any,
        personalInfo: PropTypes.any,
        presentAddress: PropTypes.any,
        presentAddressIsPermanentAddress: PropTypes.bool,
        reportingManagerId: PropTypes.string,
        companyId: PropTypes.string,
    }).isRequired,
};
Render.defaultProps = {
};

let setSubmitting = () => { };

const UserFrom = () => {
    const history = useHistory();

    // REDUX
    const dispatch = useDispatch();
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.UserReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting } = formikUtils);
        includeStamp(values);
        dispatch(userUpsertAction(values));
    }, [
        dispatch,
    ]);

    const onSearch = useCallback(({
        userId,
        employmentType,
        userType,
        designation,
        reportingManagerId,
        personalInfo,
        presentAddress,
        bankInfo,
    }) => {
        history.push(RoutingUtil.userSearch({
            userId,
            employmentType,
            userType,
            designation,
            reportingManagerId,
            personalInfo,
            presentAddress,
            bankInfo,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(userResetAction());
    }, [
        dispatch,
    ]);

    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            enableReinitialize
            initialValues={currentRecord}
            validationSchema={UserYupSchema}
            onSearch={onSearch}
        >
            {(formikProps) => (
                <Render
                    onClear={onClear}
                    onSearch={onSearch}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default UserFrom;
